import { CSSProperties, forwardRef, LegacyRef } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "../../../components";
import { IconType } from "@sellar-io/components";
export const Link = forwardRef(
  (
    {
      to,
      children,
      style,
      disabled = false,
      target = "_blank",
      icon,
    }: {
      to: string;
      style?: CSSProperties;
      disabled?: boolean;
      target?: string;
      icon?: keyof typeof IconType;
      inverse?: boolean;
      children?: string | string[];
    },
    ref: LegacyRef<HTMLAnchorElement>,
  ) => {
    return (
      <a
        href={to}
        ref={ref}
        style={style}
        target={target}
        className={twMerge(
          "flex items-center font-bold",
          disabled && "cursor-not-allowed bg-gray-500",
        )}
      >
        {children && <span>{children}</span>}
        {icon && <Icon icon={icon} className={"ml-[8px]"} />}
      </a>
    );
  },
);

Link.displayName = "Link";
